import { TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/translations'
import { FC, useCallback } from 'react'

import { useGetFormDataField } from 'cng-common/features/form'
import { FormMultiselect } from 'cng-common/features/form/components/formMultiselect/FormMultiselect'
import { ValidationType } from 'cng-common/features/form/configs'

import { periodCrud } from './configs'

import styles from './Period.module.scss'

interface IPeriodProps {
  initialValue?: string[]
  className?: string
  isDisabled?: boolean
  formKey: string
}

export const Period: FC<IPeriodProps> = ({ className, initialValue = [], isDisabled, formKey }) => {
  const [value = []] = useGetFormDataField<string[]>(formKey, 'period')

  const handleValidatePeriod = useCallback((value: string[]) => {
    if (value && value.length) {
      return ''
    }

    return 'Please, select a value'
  }, [])

  return (
    <FormMultiselect
      isSelectAllAllow
      isDisabled={isDisabled}
      isRequired={value.length === 0}
      classes={{
        controlClasses: {
          root: className,
          popPaper: styles.selectAllButton,
        },
      }}
      formKey={formKey}
      field="period"
      defaultValue={initialValue}
      source={periodCrud}
      caption="key"
      label={TRANSLATION_KEYS.keyInitiativeEditor.keyInitiativeAndPeriodFieldGroup.period}
      onValidate={handleValidatePeriod}
      validationType={ValidationType.ONCHANGE}
      isStatic
    />
  )
}

Period.displayName = 'Period'
